export default {
    validateForms:async function(formRefs) {
        let objectList = [];
        let results = formRefs.map(formRef =>
            new Promise((resolve, reject) => {
                formRef.validate((valid, object) => {
                    if (valid) {
                        resolve();
                    } else {
                        objectList.push(object);
                        reject();
                    }
                });
            })
        )
        try {
            return Promise.all(results);
        } catch (e) {
            return await Promise.reject(objectList);
        }
    },
    getDate:function(){
        var nowDate = new Date();
        var date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth() + 1,
            day: nowDate.getDate(),
        }
        return date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day)
    },
    dateDiff:function(sDate1,  sDate2) {
        sDate1 = sDate1.substring(0,10);
        sDate2 = sDate2.substring(0,10);
        var  aDate,  oDate1,  oDate2,  iDays
        aDate  =  sDate1.split("-")  
        oDate1  =  new  Date(aDate[1]  +  '-'  +  aDate[2]  +  '-'  +  aDate[0])
        aDate  =  sDate2.split("-")  
        oDate2  =  new  Date(aDate[1]  +  '-'  +  aDate[2]  +  '-'  +  aDate[0])  
        iDays  =  parseInt((oDate1  -  oDate2)  /  1000  /  60  /  60  /24)
        return  iDays  
    },
    getBase64:function (file) {
        return new Promise(function (resolve, reject) {
            let reader = new FileReader()    
            let imgResult = ''
            reader.readAsDataURL(file)    
            reader.onload = function () {      
                imgResult = reader.result    
            }
            reader.onerror = function (error) {      
                reject(error)    
            }
            reader.onloadend = function () {      
                resolve(imgResult)    
            }
        });
    },
}